export default __webpack_public_path__ + "static/media/Start_Language-EN-2.1f3976af.png";